import React from "react";
import APIService from "../../Service/APIService";
// import OrderProducts from "./OrderProducts";
import { Spin, Flex, Tag, Modal, Row, Col, Input, Button, Table, InputNumber, DatePicker, Form } from 'antd';
import './ConsignmentOrder.css'
import Swal from 'sweetalert2';
import Select from 'react-select';

const AddContactForm = (props) => {
  const { accountData } = props;
  const [prefix, setPrefix] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');

  const addContact = async () => {
    let isValidate = true;
    if (!firstName || !lastName) {
      isValidate = false;
    }
    if (!isValidate) {
      Swal.fire({
        title: 'Error!',
        text: 'Please fill all the fields',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
      return;
    }
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to add this contact to this account?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(async (result) => {
      if (result.isConfirmed) {
        console.log("Add Contact");
        const postObj = {
          AccountID: accountData?.ID,
          AccountName: accountData?.AccountName,
          Prefix: prefix,
          FirstName: firstName,
          LastName: lastName,
          Email: email,
          Phone: phone,
          Active: false,
          Type: "Contact"
        };
        console.log("Post Object: ", postObj);
        const serv = new APIService();
        const response = await serv.addDataToBackend(postObj, 'addcontact');
        console.log("Response: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire({
            icon: 'success',
            title: 'Contact Added',
            text: 'Contact has been added successfully',
          }).then(() => {
            window.location.reload();
          });
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error while adding contact',
          });
          return;
        }
      }
    });
  }

  return (
    <div>
      <Form layout='vertical'>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Account">
              <Select
                defaultValue={{ label: `${accountData?.AccountName}`, value: `${accountData?.ID}` }}
                value={{ label: `${accountData?.AccountName}`, value: `${accountData?.ID}` }}
                isDisabled={true}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item label="Prefix">
              <Input
                placeholder="Dr."
                onChange={(e) => setPrefix(e.target.value)}
                value={prefix}
              />
              <p style={{ fontSize: '12px', fontWeight: '500', color: '#616161' }}>Optional</p>
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item label="First Name">
              <Input
                placeholder="Enter First Name"
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName}
              />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item label="Last Name">
              <Input
                placeholder="Enter Last Name"
                onChange={(e) => setLastName(e.target.value)}
                value={lastName}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginTop: '-15px', marginBottom: '-10px' }}>
          <Col span={10}>
            <Form.Item label="Email">
              <Input
                placeholder="Enter Email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item label="Phone">
              <Input
                placeholder="Enter Phone"
                onChange={(e) => setPhone(e.target.value)}
                value={phone}
              />
            </Form.Item>
          </Col>
        </Row>
        <p style={{ fontSize: '16px', fontWeight: '400', color: '#2d2d2d' }}>Adding a contact does not give them access to Tissue Vault. Please contact Advanced Solution for if you want additional Tissue Vault users in your account.</p>
        <Button type='primary' style={{ background: '#27a907' }} onClick={addContact}>Add Contact</Button>

      </Form>
    </div>
  )
}

export default AddContactForm;